import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useWorkerToWorkplaceAffiliateExperiment() {
  return useCbhFlag(CbhFeatureFlag.WORKER_TO_WORKPLACE_AFFILIATE_EXPERIMENT, {
    defaultValue: false,
  });
}
